import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Attachment\SoftDeleteDossierAttachmentController::__invoke
* @see app/Http/Controllers/Dossier/Attachment/SoftDeleteDossierAttachmentController.php
* @route '/api/dossier/{dossier}/attachment/{media}'
*/
const SoftDeleteDossierAttachmentController = (args: { dossier: string | number | { id: string | number }, media: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, media: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: SoftDeleteDossierAttachmentController.url(args, options),
    method: 'delete',
})

SoftDeleteDossierAttachmentController.definition = {
    methods: ["delete"],
    url: '/api/dossier/{dossier}/attachment/{media}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Dossier\Attachment\SoftDeleteDossierAttachmentController::__invoke
* @see app/Http/Controllers/Dossier/Attachment/SoftDeleteDossierAttachmentController.php
* @route '/api/dossier/{dossier}/attachment/{media}'
*/
SoftDeleteDossierAttachmentController.url = (args: { dossier: string | number | { id: string | number }, media: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, media: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            media: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        media: typeof args.media === 'object'
        ? args.media.id
        : args.media,
    }

    return SoftDeleteDossierAttachmentController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{media}', parsedArgs.media.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Attachment\SoftDeleteDossierAttachmentController::__invoke
* @see app/Http/Controllers/Dossier/Attachment/SoftDeleteDossierAttachmentController.php
* @route '/api/dossier/{dossier}/attachment/{media}'
*/
SoftDeleteDossierAttachmentController.delete = (args: { dossier: string | number | { id: string | number }, media: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, media: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: SoftDeleteDossierAttachmentController.url(args, options),
    method: 'delete',
})

export default SoftDeleteDossierAttachmentController